export default __webpack_public_path__ + "static/media/no_available_image.6079ff46.png";